import React from 'react';
import Page from '../../../components-ui/page';
import { Box } from '@mui/material';
import Datatable from '../../../components-ui/data-table/mui';

const ThamSoPage = () => {
    return (
        <Page>
            <Box>
                <Datatable columns={[]} showPagination data={[]} />
            </Box>
        </Page>
    );
};

export default ThamSoPage;
